<template>
    <div>
        <header >
            <div style="display: flex; align-items: center;padding: 5px;">
                <!-- <el-button type="danger" size="mini" icon="el-icon-arrow-left" @click="back">返回</el-button> -->
                <el-button type="primary" size="mini" icon="el-icon-plus" @click="addOrders('queryParamsForm')">保存</el-button>
                <el-button class="css-button-3d--blue" size="mini" icon="el-icon-upload" @click="edit">箱型箱量</el-button>
                <el-button class="css-button-3d--blue1" size="mini" @click="report">
                    DEBIT NOTE
                </el-button>
                <el-button size="mini" type="success" @click="upload">上传附件</el-button>
                <el-button type="warning" size="mini" @click="searchuploadList">查看附件列表</el-button>
                <span  style="margin-left: 1vw; font-weight: bold; font-size: 1.9vh;color: #553d3e;">{{ information }}</span>
                <div v-if="profitShow === true">
                    <span class="redtext">毛利: </span>
                    <span class="profittext"  >越南盾: {{ formatMoney(Number(totalVND) - Number(totalVND1)) }}</span> 
                    <span class="profittext"> 美金: {{ formatMoney(Number(totalUSD) - Number(totalUSD1)) }}</span> 
                    <span class="profittext"> 折算本位币: {{ formatMoney(Number(totalWtVnd) - Number(totalWtVnd1)) }}</span> 
                </div>
            </div>
            <div style="display: flex;justify-content: space-between;padding-right:10px">
                <el-form style="flex:1" :inline="true" class="demo-form-inline" label-width="75px" size="mini"  :model="queryParams"  :rules="queryParamsRules" 
                ref="queryParamsForm" :show-message="false">
                    <el-form-item label="单据编号" prop="radio">
                        <el-input disabled clearable v-model="billNo"></el-input> 
                    </el-form-item>
                    <el-form-item label="业务类型" prop="businessType">
                        <el-select filterable clearable v-model="queryParams.businessType"
                            placeholder="请选择业务类型">
                            <el-option v-for="item in businessTypeList" :key="item.id" :label="item.value"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="主提单号">
                        <el-input clearable placeholder="请输入主提单号" v-model.trim="queryParams.blNo"></el-input>
                    </el-form-item>
                    <el-form-item label="分提单号">
                        <el-input clearable placeholder="请输入分提单号" v-model.trim="queryParams.subBlNo"></el-input>
                    </el-form-item>
                    <el-form-item label="委托单位">
                        <el-select filterable clearable v-model="queryParams.customer"
                            placeholder="请选择委托单位">
                            <el-option v-for="item in customOption" :key="item.id" :label="item.name"
                                :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="货物分类">
                        <el-select filterable clearable v-model="queryParams.category"
                            placeholder="请选择货物分类">
                            <el-option v-for="item in classOption" :key="item.id" :label="item.value"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="船名">
                        <el-input clearable placeholder="请输入船名" v-model="queryParams.vessel"></el-input>
                    </el-form-item>
                    <el-form-item label="航次">
                        <el-input clearable placeholder="请输入航次" v-model="queryParams.voyage"></el-input>
                    </el-form-item>
                    <el-form-item label="单证" prop="csmans"> 
                        <!-- <el-input :disabled="id === '' ? false:true" clearable v-model="queryParams.csMan"></el-input> -->
                         <el-select  :disabled="id === '' ? false:true" multiple  filterable clearable v-model="queryParams.csmans" placeholder="请选择单证">
                            <el-option v-for="item in staffOption1" :key="item.id" :label="item.userName"
                                :value="item.userName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客服" prop="trackers">
                        <!-- <el-select multiple :disabled="id === '' ? false:true" filterable clearable v-model="queryParams.tracker" placeholder="请选择客服">
                            <el-option v-for="item in staffOption1" :key="item.id" :label="item.userName"
                                :value="item.userName">
                            </el-option>
                        </el-select> -->
                        <el-select  :disabled="id === '' ? false:true" multiple  filterable clearable v-model="queryParams.trackers" placeholder="请选择客服">
                            <el-option v-for="item in staffOption1" :key="item.id" :label="item.userName"
                                :value="item.userName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item requried label="业务主管">
                        <el-input disabled clearable v-model="queryParams.manager"></el-input>
                    </el-form-item>
                    <el-form-item label="助理" prop="assistant"> 
                        <!-- :disabled="id === '' ? false:true" -->
                        <el-select  disabled filterable clearable v-model="queryParams.assistant" placeholder="请选择助理">
                            <el-option v-for="item in staffOption1" :key="item.id" :label="item.userName"
                                :value="item.userName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="报关人">
                        <el-select :disabled="id === '' ? false:true" filterable clearable v-model="queryParams.declarant"
                            placeholder="请选择报关人">
                            <el-option v-for="item in staffOption2" :key="item.id" :label="item.userName"
                                :value="item.userName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="queryParams.businessType === '出口'?'开航日':'ETA'">
                        <el-date-picker style="width: 192px;padding-left: 0px !important;" value-format="yyyy-MM-dd" v-model="queryParams.eta" type="date" placeholder="选择ETA"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="成交方式">
                        <el-select filterable clearable v-model="queryParams.tradeType"
                            placeholder="请选择成交方式">
                            <el-option v-for="item in tradeOption" :key="item.id" :label="item.value"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="目的港">
                        <el-select filterable clearable v-model="queryParams.port"
                            placeholder="请选择目的港">
                            <el-option v-for="item in portList" :key="item.id" :label="item.value"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="双星操作人" v-if="queryParams.businessType === '出口' && queryParams.customer === '双星轮胎'">
                        <el-select filterable clearable v-model="queryParams.doubleStarMan"
                            placeholder="请选择双星操作人">
                            <el-option v-for="item in doubleStarManList" :key="item.id" :label="item.value"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="货物名称" >
                        <el-input  clearable v-model="queryParams.goods" placeholder="请输入货物名称"></el-input>
                    </el-form-item>
                    <el-form-item label="所属月份" >
                        <el-date-picker style="width: 192px;padding-left: 0px !important;" value-format="yyyy-MM" v-model="queryParams.month" type="month" placeholder="请选择所属月份"> </el-date-picker>
                    </el-form-item>
                    <el-form-item label="对接人" >
                        <el-input  clearable v-model="queryParams.contactMan" placeholder="请输入对接人"></el-input>
                    </el-form-item>
                    <el-form-item label="发货编号" >
                        <el-input  clearable v-model="queryParams.voucherNo" placeholder="请输入发货编号"></el-input>
                    </el-form-item>
                    <el-form-item label="交货日期" >
                        <el-date-picker style="width: 192px;padding-left: 0px !important;" value-format="yyyy-MM-dd" v-model="queryParams.deliveryDate" type="date" placeholder="请选择交货日期"> </el-date-picker>
                    </el-form-item>
                    <el-form-item label="提柜地点" >
                        <el-input  clearable v-model="queryParams.getContainerZone" placeholder="请输入提柜地点"></el-input>
                    </el-form-item>
                    <el-form-item label="落柜地点" >
                        <el-input  clearable v-model="queryParams.putContainerZone" placeholder="请输入落柜地点"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" >
                        <el-input  clearable placeholder="请输入备注" v-model="queryParams.note"></el-input>
                        <!-- <el-input  clearable placeholder="请输入备注" v-model="queryParams.note" style="width: 473px;"></el-input> -->
                    </el-form-item>
                </el-form>
                <div style="max-width: 250px;">
                    <div>应收合计：{{ receivabletTotal }}</div>
                    <div>应付合计：{{ paymentTotal }}</div>
                </div>
            </div>
            
        </header>
        <sonQuantity ref="sonQuantity" :busId="id" :callMixinMethod="callMixinFromParent"></sonQuantity>
        <selectFee ref="selectFee" :type="type" @customEvent="handleChildArray"></selectFee>
        <!-- <fastApplication ref="fastApplication" :idArr="idArr" ></fastApplication> -->
        <fastApplication ref="fastApplication" :idArr="idArr" :applyCode="applyCode"></fastApplication>
        <main >
            <!-- 应收 -->
            <div>
                <div style="display: flex;  align-items: center;min-width: 0;">
                    <div class="title-block">
                        <span>应收</span>
                    </div>
                    <el-button @click="addRow(1)" size="mini">添加行</el-button>
                    <el-button @click="allSaveList(1)" type="primary" style="margin-left: 10px"
                        size="mini">保存全部</el-button>
                    <el-button size="mini" type="success" plain @click="quickFees('FP')">快速生成费用</el-button>
                    <!-- <el-button type="success" plain @click="importFee(1)" size="mini">导入费用模板</el-button> -->
                    <el-button size="mini" type="warning" plain @click="fastApply('FP')">发票申请</el-button>
                    <el-button size="mini" type="primary" plain @click="copAdd('FP')">复制新建</el-button>
                    <el-button size="mini" type="warning" @click="reset(1)" style="background-color: #d35400; "
                        icon="el-icon-refresh-left" circle></el-button>
                    <div>
                        <span style="padding: 20px; color: red; font-weight: bolder;font-size: large;">合计：</span>
                        <span>越南盾：</span> <span style="margin-right: 20px;" v-format="'#,##0.00'">{{ totalVND
                            }}</span>
                        <!-- <span>人民币：</span> <span style="margin-right: 20px;" v-format="'#,##0.00'">{{ totalCNY
                            }}</span> -->
                        <span>美元：</span> <span style="margin-right: 20px;" v-format="'#,##0.00'">{{ totalUSD }}</span>
                        <span>折算本位币：</span> <span v-format="'#,##0.00'">{{ totalWtVnd }}</span>
                    </div>
                </div>
                <el-table class="table-box" @selection-change="handleSelectionChange($event,'rec')" highlight-current-row
                    highlight-selection-row ref="tablelist1" :data="intableData" :header-cell-style="{ textAlign: 'center' }"
                    :empty-text="'没有数据'" border stripe height="36vh" >
                    <af-table-column type="selection" width="35" align="center">
                    </af-table-column>
                    <el-table-column label="序号" type="index" width="60" align="center">
                    </el-table-column>
                    <af-table-column prop="account" sortable label=" 结算对象 " width="150" align="left"
                        :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-select class="transparent" filterable clearable v-model="scope.row.company" placeholder="请选择结算对象"
                                v-show="scope.row.editing">
                                <el-option  v-for="item in customOption" :key="item.id" :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                            <span class="ellipsis" v-show="!scope.row.editing">{{ scope.row.company }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="account" sortable label="费用名称" width="150" align="left" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-select class="transparent" filterable clearable v-model="scope.row.feeName" placeholder="请选择费用名称"
                                v-show="scope.row.editing" @change="exitTaxRate(scope.row)">
                                <el-option v-for="item in feeOption" :key="item.id" :label="item.feeName"
                                    :value="item.feeName">
                                </el-option>
                            </el-select>
                            <span class="ellipsis" v-show="!scope.row.editing">{{ scope.row.feeName }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="containerNoList" sortable label="箱号" width="150" align="left" :render-header="addRedStar" >
                    <!-- <af-table-column prop="containerNo" sortable label="箱号" width="100" align="left" :render-header="addRedStar" > -->
                        <!-- <af-table-column prop="containerNo" label="箱号" align="center" :render-header="addRedStar"> -->
                        <template slot-scope="scope">
                            <el-select  multiple class="transparent" filterable clearable v-model="scope.row.containerNoList" placeholder="请选择箱号"
                                v-show="scope.row.editing" @focus="selectNo(scope.row,1)" @change="selectContainer(1)">
                                <el-option v-for="item in inboxNoList" :key="item.id" :label="item.containerId"
                                    :value="item.containerId">
                                    <span style="float: left">{{ item.containerId }}</span>
                                    <span style="float: right;color: #8492a6; font-size: 12px">{{ item.containerType }}</span>
                                </el-option>
                            </el-select>
                            <!-- <el-tooltip class="item" effect="dark" :content="scope.row.containerNo" placement="top-start">
                                <span class="ellipsis" v-show="!scope.row.editing">{{ scope.row.containerNo }}</span>
                            </el-tooltip> -->
                            <div class="containerNoList"  v-show="!scope.row.editing">
                                <span v-for="item in scope.row.containerNoList" style="padding:2px 0px 2px 2px;">{{ item }}</span>
                            </div>
                        </template>
                    </af-table-column>
                    <af-table-column prop="num" sortable label="数量" width="70" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" v-model="scope.row.num" placeholder="请输入数量" v-if="scope.row.editing"
                                @blur="handleBlur('num', scope.row)" @input="handleInputClear('num', scope.row)"
                                clearable></el-input>
                            <span v-show="!scope.row.editing">{{ scope.row.num }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="unit" sortable label=" 计费单位 " width="100" align="center" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-select class="transparent" filterable clearable v-model="scope.row.unit" placeholder="请选择计费单位"
                                v-show="scope.row.editing" @change="changeUnit(scope.row)">
                                <el-option v-for="item in boxOption" :key="item.id" :label="item.value"
                                    :value="item.value"></el-option>
                            </el-select>
                            <span v-show="!scope.row.editing">{{ scope.row.unit }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="unitPrice" sortable label=" 不含税单价 " width="120" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable v-model="scope.row.unitPrice" placeholder="请输入不含税单价"
                                v-if="scope.row.editing" @blur="handleBlur('unitPrice', scope.row)"></el-input>
                            <span v-show="!scope.row.editing" v-format="'#,##0.00'">{{ scope.row.unitPrice }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="taxRate" sortable label="税率(%)" width="90" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable v-model="scope.row.taxRate" placeholder="请输入税率"
                                v-if="scope.row.editing" @blur="handleBlur('taxRate', scope.row)"></el-input>
                            <span v-show="!scope.row.editing">{{ scope.row.taxRate }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="unitPriceWt" sortable label=" 含税单价 " width="110" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable v-model="scope.row.unitPriceWt" placeholder="请输入含税单价"
                                v-if="scope.row.editing" @blur="handleBlur('unitPriceWt', scope.row)"></el-input>
                            <span v-show="!scope.row.editing" v-format="'#,##0.00'">{{ scope.row.unitPriceWt
                                }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="total" sortable label=" 不含税金额 " width="115" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable v-model="scope.row.total" placeholder="请输入不含税金额"
                                v-if="scope.row.editing" @blur="handleBlur('total', scope.row)"></el-input>
                            <span v-show="!scope.row.editing" v-format="'#,##0.00'">{{ scope.row.total }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="totalWt" sortable label=" 含税金额 "  width="115" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable v-model="scope.row.totalWt" placeholder="请输入金额"
                                v-if="scope.row.editing" @blur="handleBlur('totalWt', scope.row)"></el-input>
                            <span v-show="!scope.row.editing" v-format="'#,##0.00'">{{ scope.row.totalWt }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="currency" sortable label="币制"  width="70" align="center" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-select  class="transparent" filterable clearable v-model="scope.row.currency" placeholder="请选择币制"
                                v-show="scope.row.editing" @change="exitCurrency(scope.row)">
                                <el-option v-for="item in typeOption" :key="item.id" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-show="!scope.row.editing">{{ scope.row.currency }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="exchangeRate" sortable label="汇率" width="70" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" v-model="scope.row.exchangeRate" placeholder="请输入汇率" v-if="scope.row.editing && scope.row.currency !== 'VND'"
                                clearable @blur="handleBlur('exchangeRate', scope.row)"></el-input>
                            <span v-show="!scope.row.editing || scope.row.currency === 'VND' ">{{ scope.row.exchangeRate }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="createMan" sortable label="录入人" width="90" align="center"
                    :filters="createManFiltersReceive" :filter-method="filterHandler" >
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable disabled v-model="scope.row.createMan" placeholder="录入人"
                                v-if="scope.row.editing"></el-input>
                            <span v-show="!scope.row.editing">{{ scope.row.createMan }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="finance" sortable label="未核销金额" width="115" align="right">
                        <template slot-scope="scope">
                            <span v-format="'#,##0.00'">{{ scope.row.totalWt - scope.row.finance }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="totalWtVnd" sortable label=" 折算本位币 " width="115" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <span  v-format="'#,##0.00'">{{ scope.row.totalWtVnd }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="note" label="备注" >
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable v-model="scope.row.note" placeholder="请输入备注"
                                v-if="scope.row.editing"></el-input>
                            <span v-show="!scope.row.editing">{{ scope.row.note }}</span>
                        </template>
                    </af-table-column>
                    
                    <af-table-column label="操作" align="center" fixed="right" width="135">
                        <template slot-scope="scope">
                            <el-button v-if="!scope.row.editing" @click="feeVoucher(scope.row)" type="text" size="small"> 查看收款 </el-button>
                            <el-button v-if="!scope.row.editing" @click="startEditing(scope.row, 1)" type="text" size="small"> 编辑 </el-button>
                            <el-button v-else @click="save(scope.row, 1)" type="text" size="small"> 保存 </el-button>
                            <el-button  @click="deleteRow(scope.row)" type="text" size="small" style="margin-left: 10px">删除</el-button>
                            <el-button v-if="scope.row.editing" @click="startEditing2(scope.row, 2)" type="text" size="small"> 退出 </el-button>
                        </template>
                    </af-table-column>
                </el-table>
            
            </div>
            <!-- 应付       -->
            <div style="margin-top: 5px;">
                <div style="display: flex;  align-items: center;min-width: 0;">
                    <div class="title-block">
                        <span>应付</span>
                    </div>
                    <el-button size="mini" @click="addRow(2)">添加行</el-button>
                    <el-button size="mini" @click="allSaveList(2)" type="primary"
                        style="margin-left: 10px">保存全部</el-button>
                    <el-button size="mini" type="success" plain @click="quickFees('FK')">快速生成费用</el-button>
                    <!-- <el-button size="mini" type="success" plain @click="importFee(2)">导入费用模板</el-button> -->
                    <el-button size="mini" type="warning" plain @click="fastApply('FK')">资金申请</el-button>
                    <el-button size="mini" type="primary" plain @click="copAdd('FK')">复制新建</el-button>
                    <el-button size="mini" type="warning" @click="reset(2)" style="background-color: #d35400; "
                        icon="el-icon-refresh-left" circle></el-button>
                    <el-button size="mini" type="warning" @click="transferIntable()"
                        style="background-color: #a04e8f; border: 0;">转应收</el-button>
                    <div>
                        <span style="padding: 20px; color: red; font-weight: bolder;font-size: large;">合计：</span>
                        <span>越南盾：</span> <span style="margin-right: 20px;" v-format="'#,##0.00'">{{ totalVND1 }}</span>
                        <span>美元：</span> <span style="margin-right: 20px;" v-format="'#,##0.00'">{{ totalUSD1 }}</span>
                        <span>折算本位币：</span> <span v-format="'#,##0.00'">{{ totalWtVnd1 }}</span>
                    </div>
                </div>
                <el-table @selection-change="handleSelectionChange($event,'pay')" ref="tablelist2" highlight-current-row :header-cell-style="{ textAlign: 'center' }"
                    highlight-selection-row class="table-box" :data="extableData" border height="36vh" 
                    :empty-text="'没有数据'"  stripe >
                    <af-table-column type="selection" width="35" align="center"></af-table-column>
                    <af-table-column label="序号"  type="index" width="60" align="center"></af-table-column>
                    <af-table-column prop="company" sortable label=" 结算对象 " width="150" align="left"  :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-select class="transparent" filterable clearable v-model="scope.row.company" placeholder="请选择结算对象"
                                v-show="scope.row.editing">
                                <el-option v-for="item in customOption" :key="item.id" :label="item.name"
                                    :value="item.name"></el-option>总计 费
                            </el-select>
                            <span class="ellipsis" v-show="!scope.row.editing">{{ scope.row.company }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="feeName" sortable label="费用名称" width="150" align="left" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-select class="transparent" filterable clearable v-model="scope.row.feeName" placeholder="请选择费用名称"
                                v-show="scope.row.editing" @change="exitTaxRate(scope.row)">
                                <el-option v-for="item in feeOption" :key="item.id" :label="item.feeName"
                                    :value="item.feeName"></el-option>
                            </el-select>
                            <span class="ellipsis" v-show="!scope.row.editing">{{ scope.row.feeName }}</span>
                        </template>
                    </af-table-column>
                    <!-- <af-table-column prop="containerNo" sortable label="箱号" width="100"  align="left" :render-header="addRedStar"> -->
                    <af-table-column prop="containerNoList" sortable label="箱号" width="155"  align="left" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-select  multiple  class="transparent" filterable clearable v-model="scope.row.containerNoList" placeholder="请选择箱号"
                                v-show="scope.row.editing" @focus="selectNo(scope.row,2)" @change="selectContainer(2)">
                                <el-option v-for="item in exboxNoList" :key="item.id" :label="item.containerId"
                                    :value="item.containerId">
                                    <span style="float: left">{{ item.containerId }}</span>
                                    <span style="float: right;color: #8492a6; font-size: 12px">{{ item.containerType }}</span>
                                </el-option>
                            </el-select>
                            <div class="containerNoList"  v-show="!scope.row.editing">
                                <span v-for="item in scope.row.containerNoList" style="padding:2px 0px 2px 2px;">{{ item }}</span>
                            </div>
                            <!-- <el-tooltip class="item" effect="dark" :content="scope.row.containerNo" placement="top-start">
                                <span class="ellipsis" v-show="!scope.row.editing">{{ scope.row.containerNo }}</span>
                            </el-tooltip> -->
                            <!-- <span v-show="!scope.row.editing">{{ scope.row.containerNo }}</span> -->
                        </template>
                    </af-table-column>
                    <af-table-column prop="num" sortable label="数量" align="right" width="70" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable v-model="scope.row.num" placeholder="请输入数量" v-if="scope.row.editing"
                                @blur="handleBlur('num', scope.row)"
                                @input="handleInputClear('num', scope.row)"></el-input>
                            <span v-show="!scope.row.editing">{{ scope.row.num }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="unit" sortable label=" 计费单位 " width="100" align="center" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-select class="transparent" filterable clearable v-model="scope.row.unit" placeholder="请选择计费单位"
                                v-show="scope.row.editing" @change="changeUnit(scope.row)">
                                <el-option v-for="item in boxOption" :key="item.id" :label="item.value"
                                    :value="item.value"></el-option>
                            </el-select>
                            <span v-show="!scope.row.editing">{{ scope.row.unit }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="unitPrice" sortable label=" 不含税单价 " width="120" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable v-model="scope.row.unitPrice" placeholder="请输入不含税单价"
                                v-if="scope.row.editing" @blur="handleBlur('unitPrice', scope.row)"></el-input>
                            <span v-show="!scope.row.editing" v-format="'#,##0.00'">{{ scope.row.unitPrice }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="taxRate" sortable label="税率(%)" width="90" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable v-model="scope.row.taxRate" placeholder="请输入税率" v-if="scope.row.editing"
                                @blur="handleBlur('taxRate', scope.row)"></el-input>
                            <span v-show="!scope.row.editing">{{ scope.row.taxRate }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="unitPriceWt" sortable label=" 含税单价 " width="110" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable v-model="scope.row.unitPriceWt" placeholder="请输入含税单价"
                                v-if="scope.row.editing" @blur="handleBlur('unitPriceWt', scope.row)"></el-input>
                            <span v-show="!scope.row.editing" v-format="'#,##0.00'">{{ scope.row.unitPriceWt }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="total" sortable label=" 不含税金额 " width="115" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable v-model="scope.row.total" placeholder="请输入不含税金额"
                                v-if="scope.row.editing" @blur="handleBlur('total', scope.row)"></el-input>
                            <span v-show="!scope.row.editing" v-format="'#,##0.00'">{{ scope.row.total }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="totalWt" sortable label=" 含税金额 " width="115" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable v-model="scope.row.totalWt" placeholder="请输入金额" v-if="scope.row.editing"
                                @blur="handleBlur('totalWt', scope.row)"></el-input>
                            <span v-show="!scope.row.editing" v-format="'#,##0.00'">{{ scope.row.totalWt }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="currency" sortable label="币制" align="center" width="70" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-select class="transparent" filterable clearable v-model="scope.row.currency" placeholder="请选择币制"
                                v-show="scope.row.editing" @change="exitCurrency(scope.row)">
                                <el-option v-for="item in typeOption" :key="item.id" :label="item.value"
                                    :value="item.value"></el-option>
                            </el-select>
                            <span v-show="!scope.row.editing">{{ scope.row.currency }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="exchangeRate" sortable label="汇率"  width="70" align="right" :render-header="addRedStar">
                        <template slot-scope="scope">
                            <el-input class="transparent" v-model="scope.row.exchangeRate" placeholder="请输入汇率" v-if="scope.row.editing && scope.row.currency !== 'VND'"
                                clearable @blur="handleBlur('exchangeRate', scope.row)"></el-input>
                            <span v-show="!scope.row.editing || scope.row.currency === 'VND' ">{{ scope.row.exchangeRate }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="createMan" sortable label="录入人" width="90" align="center"
                     :filters="createManFiltersPayment" :filter-method="filterHandler" >
                        <template slot-scope="scope">
                            <el-input class="transparent" clearable disabled v-model="scope.row.createMan" placeholder="录入人"
                                v-if="scope.row.editing"></el-input>
                            <span v-show="!scope.row.editing">{{ scope.row.createMan }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="finance" sortable label=" 未核销金额 " width="115" align="right">
                        <template slot-scope="scope">
                            <span v-format="'#,##0.00'">{{ scope.row.totalWt - scope.row.finance }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column prop="totalWtVnd" sortable label=" 折算本位币 " width="115" align="right" :render-header="addRedStar">
                            <template slot-scope="scope">
                                <span  v-format="'#,##0.00'" >{{ scope.row.totalWtVnd }}</span>
                            </template>
                    </af-table-column>
                    <af-table-column prop="note" label="备注"  >
                        <template slot-scope="scope">
                            <el-input clearable class="transparent" v-model="scope.row.note" placeholder="请输入备注"
                                v-if="scope.row.editing"></el-input>
                            <span v-show="!scope.row.editing">{{ scope.row.note }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column label="操作" align="center" fixed="right" width="135">
                        <template slot-scope="scope">
                            <el-button v-if="!scope.row.editing" @click="feeVoucher(scope.row)" type="text" size="small"> 查看付款 </el-button>
                            <el-button v-if="!scope.row.editing" @click="startEditing(scope.row, 2)" type="text" size="small">编辑</el-button>
                            <el-button v-else @click="save(scope.row, 2)" type="text" size="small">保存</el-button>
                            <el-button @click="deleteRow(scope.row)" type="text" size="small" style="margin-left: 10px">删除</el-button>
                            <el-button v-if="scope.row.editing" @click="startEditing2(scope.row, 2)" type="text"
                                size="small">退出</el-button>
                        </template>
                    </af-table-column>
                </el-table>

            </div>

            <el-dialog title="选择币制" :visible.sync="currDialogVisible" width="30%" center :close-on-click-modal="false">
                <el-form size="small" :model="convertForm" :rules="convertFormRule" ref="convertForm" lable-width="80px" >
                    <el-form-item  label="币制" prop="currency">
                        <el-select style="width:80%" filterable clearable v-model="convertForm.currency" placeholder="请选择币制">
                            <el-option v-for="item in typeOption" :key="item.id" :label="item.value"
                                :value="item.value"></el-option>
                        </el-select>                    
                    </el-form-item>
                    <el-form-item v-if="convertDataShow" label="汇率" prop="exchangeRate" style="margin-top: 20px;">
                        <el-input style="width:80% !important" v-model="convertForm.exchangeRate" placeholder="请输入汇率" clearable ></el-input>                
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" size="mini" @click="convertReceivable('convertForm')">确 定</el-button>
                </span>
            </el-dialog>
        </main>
        <!-- 快速生成费用 -->
         <quickFees @closeQuickFees="closeQuickFees" @quickFeesValue="quickFeesValue" :quickFeesShow="quickFeesShow" :quickFeesType="quickFeesType" :id="id"></quickFees>
        <!-- 上传附件 -->
         <el-dialog title="上传附件" :visible.sync="uploadCode" width="85%" :before-close="handleCloseUpload">
            <el-form  ref="uploadForm" label-width="100px" :inline="true"  class="demo-form-inline" size="small">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="上传报关资料">
                            <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemoveBGZL" :on-change="handleChangeBGZL"
                            multiple :file-list="fileListBGZL" :auto-upload="false">
                                <el-button  l-button size="mini" type="primary">选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="上传报关单">
                            <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemoveBGD" :on-change="handleChangeBGD"
                            multiple :file-list="fileListBGD" :auto-upload="false">
                                <el-button  l-button size="mini" type="primary">选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="上传签收单">
                            <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemoveQSD" :on-change="handleChangeQSD"
                            multiple :file-list="fileListQSD" :auto-upload="false">
                                <el-button  l-button size="mini" type="primary">选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="上传其他">
                            <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemoveQT" :on-change="handleChangeQT"
                            multiple :file-list="fileListQT" :auto-upload="false">
                                <el-button  l-button size="mini" type="primary">选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            <!-- <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemove" :on-change="handleChange"
                multiple :file-list="fileList" :auto-upload="false">
                <el-button size="small" type="primary">点击选择文件</el-button>
            </el-upload> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseUpload">取 消</el-button>
                <el-button type="primary" @click="sureUpload">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 查看上传附件 -->
        <el-dialog title="已上传附件列表" :visible.sync="searchuploadListCode" width="70%" :before-close="handleCloseUploadList">
            <el-table ref="singleTable" height="600px" :data="uploadFilesList" highlight-current-row  style="width: 100%" size="mini">
                <el-table-column type="index" width="50"> </el-table-column>
                <el-table-column prop="annexName" label="文件列表"> 
                    <template slot-scope="scope">
                        <el-link  type="primary" @click="downloadFile(scope.row)">{{ scope.row.annexName }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="annexType" label="文件类型">  </el-table-column>
                <el-table-column prop="createTime" label="上传时间">  </el-table-column>
                <el-table-column prop="createUser" label="上传人">  </el-table-column>
                <el-table-column label="操作" align="center" width="80"> 
                    <template slot-scope="scope">
                        <el-button @click="delFile(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <div class="upload_box">
                <span v-for="item,index in uploadFilesList" :key="item.id" >
                    <div  class="upload-list">
                        <el-link  type="primary" @click="downloadFile(item)">{{ item.annexName }}</el-link>
                    </div>
                </span>
            </div> -->
        </el-dialog>
        <!-- 查看费用的费用凭证 -->
        <feeVouchers :id="feeVoucherId" @closeFeeVoucher="closeFeeVoucher"></feeVouchers>
    </div>
</template>
<script src="../utils/reports/grhtml5-6.8-min.js"></script>
<script>
import sonQuantity from "@/view/sonQuantity.vue";
import selectFee from "@/view/selectFee.vue";
import quickFees from "@/components/quickFees.vue";
import fastApplication from "@/view/fastApplication.vue";
import req from '@/utils/index.js'
import url from '@/config/url1.js'
import url1 from '@/config/url2.js'
import addDetailMin from '@/mixins/addDetail.js';
import feeVouchers from "@/components/feeVouchers.vue";
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate } from "../utils/reports/grwebapp";
export default {
    name: 'addDetail',
    components: { sonQuantity, selectFee, fastApplication ,quickFees,feeVouchers},
    mixins: [addDetailMin],
    data() {
        return {
            paymentTotal:0,
            receivabletTotal:0,
            profitShow:false, // 是否显示毛利
            tradeOption:[],//贸易方式
            // tableData: [],
            formData: [],
            jsonData: {
                "master": [],
                "Table": []
            },
            jsonReport: {},
            currDialogVisible: false,//转应收选择币制
            inboxNoList:[], // 控制箱号列表--应收
            exboxNoList:[], // 控制箱号列表 -- 应付
            smallData: [],//小表格
            type: '',//传入子判断应收还是应付
            intableData: [],//收入
            extableData: [],//支出
            typeOption: [], //币制数据
            feeOption: [],//费用类型数据
            // busId:null,//djId
            // staffOption: [],//在职员工数据
            staffOption1: [],//在职员工数据
            staffOption2: [],//在职员工数据
            // staffOption3: [],//在职员工数据
            customOption: [],//委托单位数据
            classOption: [],//货物分类数据
            id: '',//单据id
            billNo: '',//单据编号
            queryParams: {
                tradeType:'',//贸易方式
                blNo: '',
                subBlNo: '',
                vessel: '',
                voyage: '',
                customer: '',
                category: '',
                // createMan: '',
                note: '',
                assistant:'',
                trackers: [],
                manager: localStorage.getItem('manager'),
                csmans: [localStorage.getItem('name')],
                declarant: '',
                eta: '',
                // deliveryDate: '',
                exchangeRate: '',//约定汇率
                port:'', // 目的港
                goods:'',
                month:'',
                contactMan:'',
                voucherNo:'',
                getContainerZone:'',
                putContainerZone:'',
            },
            portList:[], // 目的港列表
            doubleStarManList:[], // 双星操作人列表
            // 转应收表单
            convertForm:{
                currency:'',
                exchangeRate:0,
            },
            // 转应收数据
            convertData:[],
            convertDataShow:false, // 转应收汇率是否显示，选择汇率和选中数据汇率一致不显示
            businessTypeList:[], // 业务类型列表
            myself: '',
            receiveList: [],//应收表格中选中的数据
            idArr: [],//申请时传递的数据
            applyList: [],// 应付表格中选中的数据
            applyCode:'',// 申请时传递的code
            lastUnitPriceWt: null,
            lastTaxRate: null,
            lastUnitPrice: null,
            waitingForEnter: false,
            tempRowData: null,
            sendList: [],
            boxOption:[],//箱型箱量
            nowRate:0, // 今日汇率
            // 应付选中数据
            paymentSelectList:[],
            // 应收选中数据
            receiveSelectList:[],
            quickFeesShow: false, // 快速引入费用弹窗
            quickFeesType: null, 
            // 转应收规则
            feeVoucherId: '', // 查看费用凭证id
            convertFormRule:{
                currency: [
                    { required: true, message: '请选择币制', trigger: 'change' }
                ],
                exchangeRate: [
                    { required: true, message: '请输入汇率', trigger: 'change' },
                    { 
                        pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,  // 匹配非零数字（支持小数） ^(?!0+(\.0+)?$)：逆向否定预查，排除纯 0（包括 0.0、0.00 等格式）
                        message: '汇率不能为0', 
                        trigger: ['blur', 'change']
                        }
                ],
            },
            // 上传附件弹窗
            uploadCode:false,
            saveOneAttachmentURL:url1.saveOneAttachment, // 上传文件url
            fileListBGZL:[], // 上传附件列表
            fileListBGD:[], // 上传附件列表
            fileListQSD:[], // 上传附件列表
            fileListQT:[], // 上传附件列表
            uploadFilesList: [],// 已上传附件列表
            createManFiltersReceive:[], // 应收录入人过滤
            createManFiltersPayment:[], // 应付录入人过滤
            searchuploadListCode:false, // 查看附件列表窗口
            uploadedList:[], // 已上传文件列表
            queryParamsRules:{ // 订单保存校验
                trackers: [
                    { required: true, message: '请选择客服', trigger: 'change' }
                ],
                csmans:[
                    { required: true, message: '请选择单证', trigger: 'change' }
                ]
            }
        }
    },
    watch: { 
        // 监听转应收中币制变化
         'convertForm.currency' (newVal, oldVal) { 
            if(newVal === (this.convertData.length ? this.convertData[0].currency: '' )){
                this.convertDataShow = false
            }else{
                this.convertDataShow = true
            }
        },
    },
    created() {
        this.getTradeOption();
        this.getBoxOption();//箱型
        this.update();
        this.getClassOption();
        this.getcustomList();
        // this.getStaffList();
        this.getStaffList1();
        this.getStaffList2();
        // this.getStaffList3();
        this.getFeeList();
        this.getTypeOption();
        this.getAllFeeList();
        this.getNowRate();
        this.getdoubleStarManList();
        const value = localStorage.getItem('name');
        // this.queryParams.tracker = value;
        this.myself = value;
        this.getContainersDesByBusId();

    },
    mounted() {
        // webapp_urlprotocol_startup();
        webapp_ws_autoupdate();
        // this.$watch('extableData', (newValue) => {
        //     newValue.forEach(row => {
        //         this.updateFields(row);
        //     });
        // }, { deep: true });
        this.getbusinessTypeList()
        this.getportList()
        // 获取当前年份月份赋值
        if (!this.$route.query.id) {
            const date = new Date();
            const years = date.getFullYear();
            const month = date.getMonth() + 1; // 因为getMonth()返回的月份是从0开始计数的，所以需要加1
            this.queryParams.month = years + '-' + month
        }
        
    },

    computed: {

        totalUSD() {
            let total = 0;
            for (const item of this.intableData) {
                if (item.currency === 'USD') {
                    total += parseFloat(item.totalWt);
                }
            }
            return total;
        },
        totalCNY() {
            let total = 0;
            for (const item of this.intableData) {
                if (item.currency === 'RMB') {
                    total += parseFloat(item.totalWt);
                }
            }
            return total;
        },
        totalVND() {
            let total = 0;
            for (const item of this.intableData) {
                if (item.currency === 'VND') {
                    total += parseFloat(item.totalWt);
                }
            }
            return total;
        },
        // 应收合计折算本位币
        totalWtVnd(){
            let total = 0;
            for (const item of this.intableData) {
                total += parseFloat(item.totalWtVnd);
            }
            return total;
        },
        totalUSD1() {
            let total = 0;
            for (const item of this.extableData) {
                if (item.currency === 'USD') {
                    total += parseFloat(item.totalWt);
                }
            }
            return total;
        },
        totalCNY1() {
            let total = 0;
            for (const item of this.extableData) {
                if (item.currency === 'RMB') {
                    total += parseFloat(item.totalWt);
                }
            }
            return total;
        },
        totalVND1() {
            let total = 0;
            for (const item of this.extableData) {
                if (item.currency === 'VND') {
                    total += parseFloat(item.totalWt);
                }
            }
            return total;
        },
        // 应付折算本位币
        totalWtVnd1(){
            let total = 0;
            for (const item of this.extableData) {
                total += parseFloat(item.totalWtVnd);
            }
            return total;
        }
    },
    methods: {
        // 获取目的港列表
        getportList(){
            let value = '目的港';
            let URL = `${url.getDicList}/?value=${value}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.portList = res.data.data.data;
                }
            })
        },
        // 获取业务类型列表
        getbusinessTypeList(){
            let value = '业务类型';
            let URL = `${url.getDicList}/?value=${value}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.businessTypeList = res.data.data.data;
                }
            })
        },
        // 格式化金额
        formatMoney(value) {
            if (!isNaN(parseFloat(value))) {
                // 判断输入值是否为有效数字
                value = parseFloat(value)
                const parts = value.toFixed(2).split('.') // 将小数点后两位转换为字符串并按小数点切割
                parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') // 对每三位数字添加逗号分隔
                return parts.join('.') // 返回结果
            } else {
                return '' // 若输入不是有效数字则返回空字符串
            }
        },
        handleInputClear(flied,row){
            if (row.num == '' || row.num == '0') {
                row.total = '0';
                row.totalWt = '0';
                row.totalWtVnd = '0';
            }
        },        
        handleBlur(field, row) {
            if (field == 'unitPrice') {
                if (row.unitPrice == '0' || row.unitPrice == '' ) {
                    row.unitPriceWt = '0';
                    row.total = '0';
                    row.totalWt = '0';
                    row.totalWtVnd = '0';
                }else{
                    // row.unitPriceWt =  Decimal.mul(row.unitPrice,(1+row.taxRate/100));
                    row.unitPriceWt = (row.unitPrice * (1+row.taxRate/100)).toFixed(2);
                    row.total = (row.unitPrice * row.num).toFixed(2);
                    row.totalWt = (row.total*(1+row.taxRate/100)).toFixed(2);
                    row.totalWtVnd = (row.totalWt * row.exchangeRate).toFixed(2);
                }
            }
             if(field == 'num'){
                if (row.num == '0' || row.num == '' ) {
                    //    row.num == '1';
                    row.total='0';
                    row.totalWt = '0';
                    row.totalWtVnd = '0';
                }else{
                    row.total=(row.num * row.unitPrice).toFixed(2);
                    row.totalWt = (row.total*(1+row.taxRate/100)).toFixed(2);
                    row.totalWtVnd = (row.totalWt * row.exchangeRate).toFixed(2);
                }              
            }
            if (field == 'taxRate') {
                //如果没有unitPrice？
                row.unitPriceWt = (row.unitPrice * (1+row.taxRate/100)).toFixed(2);
                row.totalWt = (row.unitPriceWt * row.num).toFixed(2);
                row.totalWtVnd = (row.totalWt * (row.exchangeRate ? row.exchangeRate: 0 )).toFixed(2);
            }
            if (field == 'unitPriceWt') {
                if (row.unitPriceWt == '0' || row.unitPriceWt == '' ) {
                    row.unitPrice = '0';
                    row.total = '0';
                    row.totalWt = '0';
                    row.totalWtVnd = '0';
                }else{
                    row.unitPrice = (row.unitPriceWt / (1+row.taxRate/100)).toFixed(2);
                    row.total = (row.unitPrice * row.num).toFixed(2);
                    row.totalWt = (row.unitPriceWt * row.num).toFixed(2);
                    row.totalWtVnd = (row.totalWt * row.exchangeRate).toFixed(2);
                }
              
            }
            if (field == 'total') {
                if (row.total == '0' || row.total == '' ) {
                    row.unitPrice = '0';
                    row.unitPriceWt = '0';
                    row.totalWt = '0';
                    row.totalWtVnd = '0';
                }else{
                    row.totalWt = (row.total*(1+row.taxRate/100)).toFixed(2);
                    row.unitPriceWt = (row.totalWt / row.num).toFixed(2);
                    row.unitPrice = (row.total / row.num).toFixed(2);
                    row.totalWtVnd = (row.totalWt * row.exchangeRate).toFixed(2);
                }
                
            }
            if (field == 'totalWt') {  // 含税金额
                if (row.totalWt == '0' || row.totalWt == '' ) {
                    row.unitPrice = '0';
                    row.unitPriceWt = '0';
                    row.total = '0';
                    row.totalWtVnd = '0' // 折算本位币
                }else{
                    row.total = (row.totalWt / (1+row.taxRate/100)).toFixed(2);
                    row.unitPrice = (row.total / row.num).toFixed(2);
                    row.unitPriceWt = (row.totalWt / row.num).toFixed(2);
                    row.totalWtVnd = (row.totalWt * row.exchangeRate).toFixed(2);
                }
              
            }
            if(field == 'exchangeRate'){ // 汇率
                if (row.exchangeRate == 0 || !row.exchangeRate  ) {
                    row.totalWtVnd = 0; // 折算本位币
                }else{
                    row.totalWtVnd = ( row.exchangeRate * row.totalWt ).toFixed(2);
                }
            }
        },
        report() {
            this.reviewaPacking();
        },
        // 参数
        ws_ajax_preview() {
            //参数具体说明请参考帮助文档中的“WEB报表(B/S报表)->WEB报表客户端->启动参数说明”部分
            var args = {
                // baseurl:this.baseurl,
                // report: urlAddRandomNo("../grf/debitnote.json"),
                report: this.jsonReport,
                data: this.jsonData,
                type: "preview",
                FontEmbedding: true,  //指定嵌入字体数据
            };
            webapp_ws_ajax_run(args);
        },
        reviewaPacking() {
            // if (!(this.tableData.length > 0)) {
            //     this.$message({
            //         type: 'warning',
            //         message: '请上传文件！'
            //     })
            // } else {
            const manJson = require('../grf/debitnote.json');
            let URL = `${url.debitNote}/${this.id}`;
            req.get(URL).then(res => {
                if (res.data.code == 200) {
                    this.formData = res.data.data;
                    // delete this.formData.details;
                    // this.jsonData.Table = res.data.data.details;
                    this.jsonData.master = this.formData;
                    this.jsonReport = manJson;
                    const bgd = res.data.data.details;
                    bgd.forEach((item, index) => {
                        item["Freight & Charges"] = item.engFeeName;
                        // item["Q'ty"] = item.qty;
                        item["Unit Price"] = item.unitPrice;
                        item["Amount before Tax"] = item.amount;
                        // item["amountWt"] = item.amountWt;
                        // item["consigneeAddress"] = packingData.consigneeAddress;
                    })
                    this.jsonData.Table = bgd;
                    this.ws_ajax_preview();
                }
            })
        },
        //转应收
        transferIntable() {
            this.wheatherOrNot().then(isCan => {
                if (!isCan) {
                    return;
                } else if (isCan) {
                    if (this.paymentSelectList.length > 0) {
                        this.convertData = JSON.parse(JSON.stringify(this.paymentSelectList));// 选中数据并且不可以是编辑状态,有true则为false
                        const checkEditingStatus = (arr) => !arr.some(item => item?.editing === true);
                        if(checkEditingStatus(this.convertData) === false){
                            this.$message.error('请先保存编辑内容');
                            return false
                        }
                        // 判断选中数据的币制是否一致,不相同为false
                        const isAllSameType = (arr) => new Set(arr.map(item => item?.currency)).size <= 1;
                        if(isAllSameType(this.convertData)){
                            // 全部相同则转换
                            this.currDialogVisible = true
                        }else{
                            this.$message.error('相同币制的数据才可以一起转应收');
                            return false
                        }
                    } else {
                        this.$message.error('请选择要转应收的数据');
                    }
                }
            });
        },
        // 转应收弹窗确认
        async convertReceivable(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 判断汇率是否一致
                    if(this.convertDataShow){ // true为不一样
                        // 计算转应收价格
                        // USD转VND *汇率
                        // VND转USD /汇率
                        this.convertData.forEach(item => {
                            item.company = this.queryParams.customer;
                            item.feeType = 1;
                            item.editing = true;
                            item.finance = 0; // 未核销金额
                            const value = localStorage.getItem('name');
                            item.createMan = value;
                            // 币制
                            item.currency = this.convertForm.currency
                            // 汇率
                            item.exchangeRate = this.convertForm.exchangeRate
                            // 不含税单价
                            item.unitPrice = (this.convertForm.currency === 'VND' ? (item.unitPrice * this.convertForm.exchangeRate) : (item.unitPrice / this.convertForm.exchangeRate) ) 
                            // 含税单价
                            item.unitPriceWt = (this.convertForm.currency === 'VND' ? (item.unitPriceWt * this.convertForm.exchangeRate) : (item.unitPriceWt / this.convertForm.exchangeRate) ) 
                            // 不含税金额
                            item.total = (this.convertForm.currency === 'VND' ? (item.total * this.convertForm.exchangeRate) : (item.total / this.convertForm.exchangeRate) ) 
                            // 含税金额
                            item.totalWt = (this.convertForm.currency === 'VND' ? (item.totalWt * this.convertForm.exchangeRate) : (item.totalWt / this.convertForm.exchangeRate) ) 
                            // 未核销金额
                            item.finance = (this.convertForm.currency === 'VND' ? (item.finance * this.convertForm.exchangeRate) : (item.finance / this.convertForm.exchangeRate) ) 
                            // 折算本位币
                            item.totalWtVnd = (this.convertForm.currency === 'VND' ? (item.totalWtVnd * this.convertForm.exchangeRate) : (item.totalWtVnd / this.convertForm.exchangeRate) ) 
                            // 删除id
                            delete item.id;
                        });
                        const copyOfSelect = JSON.parse(JSON.stringify(this.convertData));
                        this.intableData.push(...copyOfSelect);
                    }else{
                        // 汇率一样直接转
                        this.convertData.forEach(item => {
                            item.company = this.queryParams.customer;
                            item.feeType = 1;
                            item.editing = true;
                            item.finance = 0;
                            const value = localStorage.getItem('name');
                            item.createMan = value;
                            delete item.id;
                        });
                        const copyOfSelect = JSON.parse(JSON.stringify(this.convertData));
                        this.intableData.push(...copyOfSelect);                
                    }
                    // 关闭弹窗，清空数据
                    this.$refs.convertForm.resetFields();
                    this.currDialogVisible = false
                    this.convertDataShow = false
                    this.convertData = []
                } else {
                    return false;
                }
            });
        },
        // 子组件son调用mixin方法刷新箱型量信息
        callMixinFromParent() {
            this.getContainersDesByBusId();
        },
        // 计算费用
        calculateCostOnTemplate() {
            // let templateId = this.sendList[0].templateId;
            let URL = `${url.calculateCost}/${this.id}/${this.sendList[0].feeType}`;
            this.sendList.forEach(item => {
                // item.amount = item.amount;
                // delete item.amount;
                item.createMan = this.myself;
                // item.editing = false;
            });
            req.post(URL, this.sendList).then(res => {
                if (res.data.code === 200) {
                    this.$message({
                        type: 'success',
                        message: res.data.message
                    })
                    let addList = [];
                    addList = res.data.data;
                    addList.forEach(item => {
                        item.editing = true;
                        item.finance = '';
                        item.note = '';
                        item.createMan = this.myself;
                        item.busId = this.id;
                        // item.exchangeRate = this.queryParams.exchangeRate;

                    });
                    if (this.sendList[0].feeType === 1) {
                        this.intableData.push(...addList);
                        // this.allSaveList(1);
                    } else if (this.sendList[0].feeType === 2) {
                        this.extableData.push(...addList);
                        // this.allSaveList(2);
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            })
        },
        //清除一个就把其他字段也都清除

        handleEnter(row) {
            this.waitingForEnter = false;
            //等待
            this.updateFields(row);
            //都存在 改变税率，只靠不含税单价和税率和数量推出含税金额和含税单价
            if (this.tempRowData && this.tempRowData.totalWt && !this.tempRowData.taxRate =='' && this.tempRowData.num && !this.tempRowData.total) {
                const calculatedUnitPriceFromTotalWt = this.calculateUnitPricePriceFromTotalWt(row);
                if (calculatedUnitPriceFromTotalWt !== null) {
                    row.unitPrice = Number(calculatedUnitPriceFromTotalWt.toFixed(2));
                }
            }
            if (this.tempRowData && this.tempRowData.unitPriceWt && !this.tempRowData.taxRate =='') {
                const calculatedUnitPrice = this.calculateunitPriceFromunitPriceWt(row);
                if (calculatedUnitPrice !== null) {
                    row.unitPrice = Number(calculatedUnitPrice.toFixed(2));
                }
            }
            if (this.tempRowData && this.tempRowData.unitPrice && !this.tempRowData.taxRate =='') {
                const taxInclusivePrice = this.calculateTaxInclusivePrice(row);
                if (taxInclusivePrice !== null) {
                    row.unitPriceWt = Number(taxInclusivePrice.toFixed(2));
                }
            }
            if (this.tempRowData && this.tempRowData.totalWt && !this.tempRowData.taxRate =='' && this.tempRowData.num && !this.tempRowData.total) {
                const calculatedUnitPriceFromTotalWt = this.calculateUnitPricePriceFromTotalWt(row);
                if (calculatedUnitPriceFromTotalWt !== null) {
                    row.unitPrice = Number(calculatedUnitPriceFromTotalWt.toFixed(2));
                }
            }
            if (this.tempRowData && this.tempRowData.total && !this.tempRowData.taxRate =='' && this.tempRowData.num && !this.tempRowData.totalWt) {
                const calculatedTaxInclusivePriceFromTotal = this.calculateTaxInclusivePriceFromTotal(row);
                if (calculatedTaxInclusivePriceFromTotal !== null) {
                    row.unitPriceWt = Number(calculatedTaxInclusivePriceFromTotal.toFixed(2));
                }
            }
            if (this.tempRowData && this.tempRowData.unitPrice && this.tempRowData.num) {
                const calculatedAmountExcludingTax = this.calculateAmountExcludingTax(row);
                if (calculatedAmountExcludingTax !== null) {
                    row.total = Number(calculatedAmountExcludingTax.toFixed(2));
                }
            }
            if (this.tempRowData && this.tempRowData.unitPriceWt && this.tempRowData.num) {
                const calculatedSum = this.calculateSum(row);
                if (calculatedSum !== null) {
                    row.totalWt = Number(calculatedSum.toFixed(2));
                }
            }
            if (this.tempRowData && this.tempRowData.totalWt && !this.tempRowData.taxRate =='' && !this.tempRowData.total) {
                const calculatedTotalFromTotalWt = this.calculateTotalFromTotalWt(row);
                if (calculatedTotalFromTotalWt !== null) {
                    row.total = Number(calculatedTotalFromTotalWt.toFixed(2));
                }
            }
            if (this.tempRowData && this.tempRowData.total && !this.tempRowData.taxRate =='' && !this.tempRowData.totalWt) {
                const calculatedTotalWtFromTotal = this.calculateTotalWtFromTotal(row);
                if (calculatedTotalWtFromTotal !== null) {
                    row.totalWt = Number(calculatedTotalWtFromTotal.toFixed(2));
                }
            }          
            // this.$nextTick(() => {
            this.tempRowData = null;
            // })

        },
        // 更新字段
        updateFields(row) {
            // 根据已有数据进行各种计算和更新
            if (row.unitPriceWt && !row.taxRate=='') {
                const calculatedUnitPrice = this.calculateunitPriceFromunitPriceWt(row);
                if (calculatedUnitPrice !== null) {
                    row.unitPrice = calculatedUnitPrice;
                }
            }
            if (row.unitPrice && !row.taxRate=='') {
                const taxInclusivePrice = this.calculateTaxInclusivePrice(row);
                if (taxInclusivePrice !== null) {
                    row.unitPriceWt = taxInclusivePrice;
                }
            }
            if (row.totalWt && !row.taxRate=='') {
                const calculatedTotalFromTotalWt = this.calculateTotalFromTotalWt(row);
                if (calculatedTotalFromTotalWt !== null) {
                    row.total = calculatedTotalFromTotalWt;
                }
            }
            if (row.total && !row.taxRate=='') {
                const calculatedTotalWtFromTotal = this.calculateTotalWtFromTotal(row);
                if (calculatedTotalWtFromTotal !== null) {
                    row.totalWt = calculatedTotalWtFromTotal;
                }
            }
            if (row.total && row.num && !row.taxRate=='' && !row.totalWt) {
                const calculatedTaxInclusivePriceFromTotal = this.calculateTaxInclusivePriceFromTotal(row);
                if (calculatedTaxInclusivePriceFromTotal !== null) {
                    row.unitPriceWt = calculatedTaxInclusivePriceFromTotal;
                }
            }
            if (row.totalWt && row.num && !row.taxRate=='' && !row.total) {
                const calculatedUnitPricePriceFromTotalWt = this.calculateUnitPricePriceFromTotalWt(row);
                if (calculatedUnitPricePriceFromTotalWt !== null) {
                    row.unitPrice = calculatedUnitPricePriceFromTotalWt;
                }
            }
            if (row.unitPrice && row.num) {
                const amountExcludingTax = this.calculateAmountExcludingTax(row);
                if (amountExcludingTax !== null) {
                    row.total = amountExcludingTax;
                }
            }
            if (row.unitPriceWt && row.num) {
                const sum = this.calculateSum(row);
                if (sum !== null) {
                    row.totalWt = sum;
                }
            }
        },
        // 从不含税单价推导含税单价
        calculateTaxInclusivePrice(row) {
            if (row.unitPrice && !row.taxRate=='') {
                const result = row.unitPrice * (1 + row.taxRate / 100);
                return Number(result.toFixed(2));
            }
            return null;
        },
        // 从含税单价推导出不含税单价
        calculateunitPriceFromunitPriceWt(row) {
            if (row.unitPriceWt && !row.taxRate=='') {
                const result = row.unitPriceWt / (1 + row.taxRate / 100);
                return Number(result.toFixed(2));
            }
            return null;
        },
        // 从含税金额推导出不含税金额
        calculateTotalFromTotalWt(row) {
            if (row.totalWt && !row.taxRate=='' && !row.total) {
                const result = row.totalWt / (1 + row.taxRate / 100);
                return Number(result.toFixed(2));
            }
            return null;
        },
        // 从不含税金额推导出含税金额
        calculateTotalWtFromTotal(row) {
            if (row.total && !row.taxRate=='' && !row.totalWt) {
                const result = row.total * (1 + row.taxRate / 100);
                return Number(result.toFixed(2));
            }
            return null;
        },
        // 从不含税金额推算出含税单价
        calculateTaxInclusivePriceFromTotal(row) {
            if (row.total && row.num && !row.taxRate=='' && !row.totalWt) {
                return Number(((row.total / row.num) * (1 + row.taxRate / 100)).toFixed(2));
            }
            return null;
        },
        // 从含税金额推算出不含税单价
        calculateUnitPricePriceFromTotalWt(row) {
            if (row.totalWt && row.num && !row.taxRate==''  && !row.total) {
                return Number(((row.totalWt / row.num) / (1 + row.taxRate / 100)).toFixed(2));
            }
            return null;
        },
        // 计算不含税金额
        calculateAmountExcludingTax(row) {
            if (row.unitPrice && row.num) {
                const result = row.unitPrice * row.num;
                return Number(result.toFixed(2));
            }
            return null;
        },
        // 计算含税金额
        calculateSum(row) {
            if (row.unitPriceWt && row.num) {
                const result = row.unitPriceWt * row.num;
                return Number(result.toFixed(2));
            }
            return null;
        },
        //小表格
        smallTable() {
            if(this.id !== ''){
                let URL = `${url.getContainerList}/${this.id}`;
                req.get(URL).then(res => {
                    if (res.data.code === 200) {
                        this.smallData = res.data.data;
                        // setTimeout(() => {
                        //     this.$nextTick(() => {
                        //         this.$refs.table.doLayout()
                        //     })
                        // }, 300)
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        })
                    }
                })
            }else{
                this.$message({
                    type: 'error',
                    message: '请先保存主任务'
                })
            }
        },
        // 关闭弹窗后idArr等清空
        clearIdArr() {
            this.idArr = []
            this.receiveList = []
            this.applyList = []
        },
        // 刷新按钮
        reset(val) {
            if(this.id !== ''){
                if (val === 1) {
                    let URL = `${url1.getInComeList}/${this.id}`;
                    req.get(URL).then(res => {
                        if (res.data.code === 200) {
                            // 箱号多选列表
                            res.data.data.incomeList.map(item => {
                                item.containerNoList = item.containerNo.split(',');
                                item.editing = false
                            })
                            this.intableData = res.data.data.incomeList;
                            this.selectContainer(val)
                            // this.intableData.forEach(row => {
                            //     this.$set(row, 'editing', false);
                            // });
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }
                    })
                } else if (val === 2) {
                    let URL = `${url1.getInComeList}/${this.id}`;
                    req.get(URL).then(res => {
                        if (res.data.code === 200) {
                            res.data.data.expenseList.map(item => {
                                item.containerNoList = item.containerNo.split(',');
                                item.editing = false
                            })
                            this.extableData = res.data.data.expenseList;
                            this.selectContainer(val)
                            // this.extableData.forEach(row => {
                            //     this.$set(row, 'editing', false);
                            // });
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }
                    })
                }  
            }else{
                this.$message({
                    type: 'error',
                    message: '请先保存主任务'
                })
            }
        },
        // 表格选择
        handleSelectionChange(val,code) {
            if (val.length > 0) {
                if (val[0].feeType == 1) {
                    this.$refs.tablelist1.setCurrentRow();
                    this.receiveSelectList = val
                    this.receiveList = val.map(item => item.id);
                    this.receivabletTotal = val.reduce((total, item) => total + item.totalWtVnd, 0)
                } else if (val[0].feeType == 2) {
                    this.$refs.tablelist2.setCurrentRow();
                    this.paymentSelectList = val
                    this.applyList = val.map(item => item.id);
                    this.paymentTotal = val.reduce((total, item) => total + item.totalWtVnd, 0)
                }
            } else {
                if(code === 'pay'){
                    this.paymentTotal = 0
                    this.paymentSelectList = []
                }else{
                    this.receivabletTotal = 0
                    this.receiveSelectList = []
                }
                return
            }
        },
        // 计费单位改变后，清空箱号
        // changeUnit(data){
        //     data.containerNo = ''
        // },
        // 2. 根据计费单位控制可选箱号列表
        // 1. 点击编辑后判断计费单位,初始化箱号列表
        selectNo(data,code){
            if(code === 1){
                this.inboxNoList = this.smallData
            //     this.inboxNoList = this.smallData.filter(val =>{
            //         return val.containerType === data.unit
            //     })
            }else{
                this.exboxNoList = this.smallData
            //     this.exboxNoList = this.smallData.filter(val =>{
            //         return val.containerType === data.unit
            //     })
            }
        },
        //快速申请发票和付款
        fastApply(code) {
            this.applyCode = code;
            var selectList = []
            if(code === 'FK'){
                this.idArr = [...this.applyList];
                selectList = this.paymentSelectList
            }else{
                this.idArr = [...this.receiveList];
                selectList = this.receiveSelectList
            }
            // 资金申请只能申请自己的费用，发票不限制
            this.$nextTick(() => {
                if (!this.idArr.length) {
                    this.$message.error('请选择要申请的' + (code === 'FK' ?'付款' : '发票') + '!');
                    return
                } else {
                    // 判断资金申请时选中的数据不是可编辑状态
                    const checkEditingStatus = (arr) => !arr.some(item => item?.editing === true);
                    if(checkEditingStatus(selectList)){
                        this.$refs.fastApplication.fastApply(this.id);
                    }else{
                        this.$message.error('请先保存编辑内容');
                        return false
                    }
                }
            }); 
            // this.$refs.fastApplication.dialogFormVisible = true;
        },
        //接子组件费用模板数据
        handleChildArray(arrayFromChild) {
            // 这里接收到了子组件传递过来的数组
            this.sendList = arrayFromChild;
        },
        importFee(type) {
            if(this.id !== ''){
                if (type == 1) {
                    this.wheatherOrNot().then(isCan => {
                        if (!isCan) {
                            return;
                        } else if (isCan) {
                            this.type = type;
                            this.$refs.selectFee.dialogTableVisible = true;
                            this.$refs.selectFee.getData(this.id);
                        }
                    });
                } else if (type == 2) {
                    this.type = type;
                    this.$refs.selectFee.dialogTableVisible = true;
                    this.$refs.selectFee.getData(this.id);
                }
            }else{
                this.$message.error('请先保存订单后后再导入费用模板！');
            }
        },
        // 快速录入费用
        quickFees(code){
            // 打开弹窗
            if(this.id !== ''){
                if (code == 'FP') {
                    this.wheatherOrNot().then(isCan => {
                        if (!isCan) {
                            return;
                        } else if (isCan) {
                            this.quickFeesShow = true;
                            this.quickFeesType = 1;
                        }
                    });
                } else {
                    this.quickFeesShow = true;
                    this.quickFeesType = 2;
                }
            }else{
                this.$message.error('请先保存订单后后再快速引入费用！');
            }
        },
        // 关闭快速引入费用弹窗
        closeQuickFees(data){
            this.quickFeesShow = data;
        },
        // 引入费用返回值
        quickFeesValue(data){
            let addList = [];
            addList = data;
            addList.forEach(item => {
                item.editing = true;
                item.finance = '';
                item.note = '';
                item.createMan = this.myself;
                item.busId = this.id;
                item.containerNoList = item.containerNo.split(',');
            });
            if (data[0].feeType === 1) {
                this.intableData.push(...addList);
            } else if (data[0].feeType === 2) {
                this.extableData.push(...addList);
            }
        },
        addRow(type) {
            const newRow = {
                feeType: type,
                feeName: '',
                company: '',
                total: '0',
                currency: '',
                taxRate:'0.00',
                totalWt: '0',
                unitPrice: '0',
                unitPriceWt: '0',
                unit:'',
                finance:'',
                exchangeRate: this.queryParams.exchangeRate,
                num: 1,
                editing: true,
                busId: this.id,
                createMan: this.myself,
                totalWtVnd:'0',
                containerNo:'',
                containerNoList:[], // 多选箱号列表
            };
            if(this.id !== ''){
                if (type === 1) {
                    this.wheatherOrNot().then(isCan => {
                        if (!isCan) {
                            return;
                        } else if (isCan) {
                            this.intableData.push(newRow);
                            this.inboxNoList = []
                        }
                    });
                
                } else if (type === 2) {
                    this.extableData.push(newRow);
                    this.exboxNoList = []
                }
            }else{
                this.$message.error('请先保存订单后后再添加费用');
            }
        },
        deleteRow(row) {
            if(row.createMan !== localStorage.getItem('name')){
                this.$message.error('不是本人创建的费用信息不可删除');
                return false
            }
             if (row.finance > 0) {
                // 删除行的逻辑
                 this.$message.error('该费用存在核销记录，不允许删除！');
                }else {
                    // 查看费用凭证，弹出提醒
                    let feeVoucherLength = 0
                    let URL = `${url1.getFeeVoucher}/${this.id}`;
                    req.get(URL).then(res => {
                        if (res.data.code === 200) {
                            feeVoucherLength = res.data.data.length
                        }
                    })
                    if(feeVoucherLength === 0){
                            if (row.feeType == 1) {
                                const index = this.intableData.indexOf(row);
                                if (index !== -1) {
                                    this.intableData.splice(index, 1);
                                }
                            } else if (row.feeType == 2) {
                                const index = this.extableData.indexOf(row);
                                if (index !== -1) {
                                    this.extableData.splice(index, 1);
                                }
                            }
                            if (row.id) {
                                let URL = `${url1.deleteFee}/${row.id}`;
                                req.delete(URL).then(res => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            type: 'success',
                                            message: '删除成功'
                                        })
                                        this.getAllFeeList();
                                    } else {
                                        this.$message({
                                            type: 'error',
                                            message: res.data.message
                                        })
                                        this.getAllFeeList();
                                    }
                                })
                            }   
                        }else{
                            this.feeVoucherId = row.id
                        }
            }

        },
        // 退出

        // const newRow = {
        //         feeType: type,
        //         feeName: '',
        //         company: '',
        //         total: '0',
        //         currency: '',
        //         taxRate:'0.00',
        //         totalWt: '0',
        //         unitPrice: '0',
        //         unitPriceWt: '0',
        //         unit:'',
        //         finance:'',
        //         exchangeRate: this.queryParams.exchangeRate,
        //         num: 1,
        //         editing: true,
        //         busId: this.id,
        //         createMan: this.myself,

        //     };
        startEditing2(row,type){
            if(!row.id){
                // 没id的费用直接删除
                if (row.feeType == 1) {
                    const index = this.intableData.indexOf(row);
                    if (index !== -1) {
                        this.intableData.splice(index, 1);
                    }
                } else if (row.feeType == 2) {
                    const index = this.extableData.indexOf(row);
                    if (index !== -1) {
                        this.extableData.splice(index, 1);
                    }
                }
            }else{
                // 有id的费用信息退出
                if (row.finance != '0') {
                    this.$set(row, 'editing', false);
                    this.$set(row, 'total', '0');
                    this.$set(row, 'totalWt', '0');
                    this.$set(row, 'finance', '0');
                    this.$set(row, 'unitPrice', '0');
                    this.$set(row, 'unitPriceWt', '0');
                    this.$set(row, 'unit', '0');
                    this.$set(row, 'taxRate', '0.00');
                    this.$set(row, 'num', 1);
                    this.$set(row, 'feeName', '');
                    this.$set(row, 'company', '');
                }else{
                    this.$set(row, 'editing', false);
                }
            }
        },
        startEditing(row,type) {
            if(row.createMan !== localStorage.getItem('name')){
                this.$message.error('不是本人创建的费用信息不可编辑');
                return false
            }
            if (row.finance != '0') {
                this.$message.error('该费用存在核销记录，不允许修改！');
                // this.$message.error('该费用存在核销记录，不允许修改！');
                // row.finance == '0';               
            }else{
                this.$set(row, 'editing', true);
                // if(type === 1) {  // 应收
                    setTimeout(() => {
                        this.selectContainer(type)
                    },100)
                    // this.inboxNoList = this.smallData.filter(val =>{
                    //     return val.containerType === row.unit
                    // })
                    // this.inboxNoList = this.smallData
                // }else{
                    // this.exboxNoList = this.smallData
                    // this.exboxNoList = this.smallData.filter(val =>{
                    //     return val.containerType === row.unit
                    // })
            // }            
                // if (row.editing == true) {
                //     this.$set(row, 'editing', false);
                // } else {
                //     this.$set(row, 'editing', true);
                // }
            }
        },
        // 修改表格高度
        selectContainer(type){
            if(type === 1) {  // 应收
                setTimeout(() => {
                    this.$nextTick(() => {
                        const table = this.$refs.tablelist1;
                        if (table) {
                            table.doLayout(); // 重新计算布局
                            const bodyRows = table.$el.querySelectorAll('.el-table__body-wrapper tr');
                            const fixedRows = table.$el.querySelectorAll('.el-table__fixed-body-wrapper tr');
                            bodyRows.forEach((row, index) => {
                                if (fixedRows[index]) {
                                    fixedRows[index].style.height = `${row.offsetHeight}px`;
                                }
                            });
                        }
                    });
                },100)
            }else{
                setTimeout(() => {
                    this.$nextTick(() => {
                        const table = this.$refs.tablelist2;
                        if (table) {
                            table.doLayout(); // 重新计算布局
                            const bodyRows = table.$el.querySelectorAll('.el-table__body-wrapper tr');
                            const fixedRows = table.$el.querySelectorAll('.el-table__fixed-body-wrapper tr');
                            bodyRows.forEach((row, index) => {
                                if (fixedRows[index]) {
                                    fixedRows[index].style.height = `${row.offsetHeight}px`;
                                }
                            });
                        }
                    });
                },100)
            }            
        },
        // 确定保存
        allSaveList(type) {
            let hasEmptyValue = false;
            if (type == 1) {
                // 箱号列表变成字符串
                this.intableData.map(item=>{
                    item.containerNo = item.containerNoList.join(',')
                })
                if(this.intableData.length){
                    this.intableData.forEach(row => {
                        if (!row.feeName || !row.company || !row.total || !row.currency || !row.unitPrice || !row.unitPriceWt 
                            || !row.totalWt || !row.exchangeRate || !row.num || !row.unit || !row.containerNo || !row.totalWtVnd) {
                            hasEmptyValue = true;
                            return false; // 提前退出循环
                        }
                    });
                }else{
                    hasEmptyValue = true;
                }
                
            } else if (type == 2) {
                // 箱号列表变成字符串
                this.extableData.map(item=>{
                    item.containerNo = item.containerNoList.join(',')
                })
                if(this.extableData.length){
                    this.extableData.forEach(row => {
                        if (!row.feeName || !row.company || !row.total || !row.currency || !row.unitPrice || !row.unitPriceWt 
                            || !row.totalWt || !row.exchangeRate || !row.num || !row.unit || !row.containerNo || !row.totalWtVnd) {
                            hasEmptyValue = true;
                            return false; // 提前退出循环
                        }
                    });
                }else{
                    hasEmptyValue = true;
                }
            } else {
                console.log('应付应收feeType类别错误');
            }
            if (hasEmptyValue) {
                this.$message.warning('请填写完整空白内容');
            } else {
                let URL = `${url1.addFee}`;
                if (type == 1) {
                    // 筛选 exit 为 true 的对象
                    const tableData = this.intableData.filter(item => item.editing === true);
                    req.post(URL, tableData).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '更改成功'
                            })
                            this.intableData.forEach(row => {
                                this.$set(row, 'editing', false);
                            });
                            this.getAllFeeList();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }
                        this.reset(type)
                    })
                } else if (type == 2) {
                    // 筛选 exit 为 true 的对象
                    const tableData = this.extableData.filter(item => item.editing === true);
                    req.post(URL, this.extableData).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '更改成功'
                            })
                            this.extableData.forEach(row => {
                                this.$set(row, 'editing', false);
                            });
                            this.getAllFeeList();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                            this.reset(type)
                        }
                    })
                }

            }

        },
        //单条保存
        save(row,type) {
            row.containerNo = row.containerNoList.join(',')
            if (!row.feeName || !row.company || !row.total || !row.currency || !row.unitPrice || !row.unitPriceWt || !row.totalWt || !row.exchangeRate || !row.num || !row.unit || !row.containerNo) {
                this.$message.warning('请填写完整空白内容');
            } else {
                this.$set(row, 'editing', false);
                let obj = [];
                obj.push(row);
                let URL = `${url1.addFee}`;
                req.post(URL, obj).then(res => {
                    if (res.data.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '更改成功'
                        })
                        this.getAllFeeList();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        })
                        this.reset(type)
                    }
                })
            }
        },
        //获取应收应付数据
        getAllFeeList() {
            if(this.id !== ''){
                let URL = `${url1.getInComeList}/${this.id}`;
                req.get(URL).then(res => {
                    if (res.data.code === 200) {
                        res.data.data.incomeList.map(item => {
                            item.containerNoList = item.containerNo.split(',');
                            item.editing = false
                        })
                        this.intableData = res.data.data.incomeList;
                        // 过滤出录入人数据
                        this.createManFiltersReceive = [
                            ...new Map(this.intableData.map (item => [item.createMan,{ text: item.createMan, value: item.createMan }])).values()
                        ]
                        // this.intableData = this.intableData.map(item => {
                        //     item.totalWtVnd = item.exchangeRate * item.totalWt;
                        //     return item;
                        // });
                        // this.intableData.forEach(row => {
                        //     this.$set(row, 'editing', false);
                        // });
                        res.data.data.expenseList.map(item => {
                            item.containerNoList = item.containerNo.split(',');
                            item.editing = false
                        })
                        this.extableData = res.data.data.expenseList;
                        // 过滤出录入人数据
                        this.createManFiltersPayment =  [
                            ...new Map(this.extableData.map (item => [item.createMan,{ text: item.createMan, value: item.createMan }])).values()
                        ]
                        this.selectContainer(1)
                        this.selectContainer(2)
                        // this.extableData = this.extableData.map(item => {
                        //     item.totalWtVnd = item.exchangeRate * item.totalWt;
                        //     return item;
                        // });
                        // this.extableData.forEach(row => {
                        //     this.$set(row, 'editing', false);
                        // });
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        })
                    }
                })
            }
        },
        //鉴权是否可以新增应收
        async wheatherOrNot() {
            if(this.id !== ''){
                // 判断当前用户名字是否和订单业务主管/客服名字相同
                const name = localStorage.getItem('name')
                if(  name === this.queryParams.manager || name === this.queryParams.assistant || localStorage.getItem('role') === '领导' || this.queryParams.trackers.indexOf(name) !== -1
            || name === this.queryParams.declarant){
                    return true;
                }else {
                    this.$message({
                        type: 'error',
                        message: '暂无权限,只有业务主管和客服可以操作'
                    });
                    return false;
                }

            }else{
                this.$message({
                    type: 'error',
                    message: '请先保存费用'
                });
                return false;
            }
        },
        //箱型箱量弹框
        edit() {
            if (this.billNo) {
                this.$refs.sonQuantity.dialogCartonVisible = true;
            } else {
                this.$message({
                    type: 'error',
                    message: '请先保存单据！'
                })
            }

        },
        // 添加订单
        addOrders(formName) {
            // if (this.queryParams.manager == '') {
            //     this.$message({
            //         type: 'error',
            //         message: '请先选择客户经理！'
            //     })
            // }else{
            // 判断双星操作人
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.queryParams.businessType !== '出口' || this.queryParams.customer !== '双星轮胎'){
                        this.$delete(this.queryParams, 'doubleStarMan'); 
                    }
                        // 客户多选，将返回值改为字符串，用|链接
                        // this.queryParams.tracker  = this.queryParams.tracker.join('|');
                        let URL = `${url.createBill}/`;
                        if (this.id) {
                            let queryParams = this.queryParams;
                            queryParams.id = this.id;
                            req.post(URL, queryParams).then(res => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.message
                                    })
                                    this.smallTable();
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.message
                                    })
                                }
                            })
                        } else {
                            req.post(URL, this.queryParams).then(res => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.message
                                    })
                                    const parts = res.data.data.split('|');
                                    this.billNo = parts[1];
                                    this.id = parts[0];
                                    this.busIdMin = parts[0];
                                    this.smallTable();
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.message
                                    })
                                }
                            })
                        }
                } else {
                    this.$message.error('请选择客服');
                    return false;
                }
            });

        },
        // 跳转页面后修改数据
        update() {
            if (this.$route.query.id) {
                const id = this.$route.query.id;
                this.id = id;
                this.busIdMin = id;
                let URL = `${url.getById}/${id}`;
                req.get(URL).then(res => {
                    if (res.data.code === 200) {
                        this.queryParams = res.data.data;
                        // this.queryParams.tracker = [this.queryParams.tracker]
                        this.billNo = res.data.data.billNo;
                        this.smallTable();
                        // 判断当前用户数是否为客户经理或领导身份或财务身份,不是的话不能看上方毛利
                        if(this.queryParams.manager === localStorage.getItem('name') || localStorage.getItem('role') === '领导'
                         || localStorage.getItem('role') === '财务' || this.queryParams.trackers.indexOf(localStorage.getItem('name')) !== -1){
                                this.profitShow = true
                            // this.$forceUpdate();
                        }

                    }
                })
            }

        },
        // 查询已上传附件
        getFileListByBusinessId(){
            let fileURL = `${url1.getFileListByBusinessId}/${this.id}`;
            req.get(fileURL).then(res => { 
                this.uploadFilesList = res.data.data;
            })
        },
            
        // 获取货物分类数据
        getClassOption() {
            let value = '货物分类';
            let URL = `${url.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.classOption = res.data.data.data;
                }
            })
        },
        //获取箱型箱量
        getBoxOption() {
            let value = '箱型';
            let URL = `${url.getDicList}/?value=${value}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.boxOption = res.data.data.data;
                }
            })
        },
         //获取贸易方式
         getTradeOption() {
            let value = '贸易方式';
            let URL = `${url.getDicList}/?value=${value}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.tradeOption = res.data.data.data;
                }
            })
        },
        //获取委托单位数据
        getcustomList() {
            let URL = `${url1.getList}/?name=${this.queryParams.customer}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.customOption = res.data.data;
                }
            })
        },
        //获得客户经理数据
        // getStaffList() {
        //     let URL = `${url.getUserByRole}/客户经理`;
        //     req.get(URL).then(res => {
        //         if (res.data.code === 200) {
        //             this.staffOption = res.data.data;
        //         }
        //     })
        // },
         //获得客户经理数据
         getStaffList1() {
            let URL = `${url.getUserByRole}/跟单`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.staffOption1 = res.data.data;
                    this.staffOption1.push({userName: localStorage.getItem('name'),id:'itself'})
                    // 客服下拉列表不能有本人
                    const uniqueArr = this.staffOption1.reduce((acc, current) => {
                        const isDuplicate = acc.some(item => 
                            item.userName === current.userName
                        );
                        if (!isDuplicate) {
                            acc.push(current);
                        }
                        return acc;
                    }, []);
                    this.staffOption1 = uniqueArr
                }
            })
        },
         //获得客户经理数据
         getStaffList2() {
            let URL = `${url.getUserByRole}/报关`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.staffOption2 = res.data.data;
                }
            })
        },
        //获得客户经理数据--单证
        // getStaffList3() {
        //     let URL = `${url.getUserByRole}/单证`;
        //     req.get(URL).then(res => {
        //         if (res.data.code === 200) {
        //             this.staffOption3 = res.data.data;
        //         }
        //     })
        // },

        //获得费用名称
        getFeeList() {
            let URL = `${url.fee}?feeName=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.feeOption = res.data.data;
                }
            })
        },
        //获得币制数据
        getTypeOption() {
            let value = '币制';
            let URL = `${url.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.typeOption = res.data.data.data;
                }
            })
        },
        // 获取双星操作人列表
        getdoubleStarManList(){
            let value = '双星操作人';
            let URL = `${url.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.doubleStarManList = res.data.data.data;
                }
            })
        },
        //表头加星号
        addRedStar(h, { column }) {
            return [
                h("span", { style: "color: red" }, "*"),
                h("span", " " + column.label),
            ];
        },
        //返回
        back() {
            this.$router.push({
                path: "/orderManagement"
                // query: { id: row },
            });
            // window.location.go(-1); 
        },
        // 查询今日汇率
        getNowRate(){
            let URL = `${url1.getNowRate}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.nowRate = res.data.data;
                }
            })
        },
        // 修改币制后，汇率跟着变化，VDN不变不可编辑；USD变成今日汇率并可编辑
        exitCurrency(data){
            if(data.currency === 'USD'){
                data.exchangeRate = this.nowRate
                if(data.unitPrice !== '0' && data.unitPrice !== ''){
                    data.totalWtVnd = (data.totalWt * data.exchangeRate).toFixed(2);
                }
            }else if(data.currency === 'VND'){
                data.exchangeRate = 1
                if(data.unitPrice !== '0' && data.unitPrice !== ''){
                    data.totalWtVnd = (data.totalWt * data.exchangeRate).toFixed(2);
                }
            }
        },
        // 修改费用名称后，税率跟着变化
        exitTaxRate(data){
            let URL = `${url.fee}`;
            req.get(URL,{
                params:{
                    feeName:data.feeName,
                }
            }).then(res => {
                if (res.data.code == 200) {
                    data.taxRate = Number(res.data.data[0].tax)
                    this.handleBlur('taxRate', data)
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        // 打开上传附件接口
        upload(){
            // 打开上传附件弹窗
            this.uploadCode = true
        },
        // 文件上传时勾子
        handleChangeBGZL(file, fileList){
            this.fileListBGZL = fileList;
        },
        // 移除文件勾子
        handleRemoveBGFP(file, fileList){
            this.fileListBGZL = fileList;
        },
        // 文件上传时勾子
        handleChangeBGD(file, fileList){
            this.fileListBGD = fileList;
        },
        // 移除文件勾子
        handleRemoveBGD(file, fileList){
            this.fileListBGD = fileList;
        },
        // 文件上传时勾子
        handleChangeQSD(file, fileList){
            this.fileListQSD = fileList;
        },
        // 移除文件勾子
        handleRemoveQSD(file, fileList){
            this.fileListQSD = fileList;
        },
        // 文件上传时勾子
        handleChangeQT(file, fileList){
            this.fileListQT = fileList;
        },
        // 移除文件勾子
        handleRemoveQT(file, fileList){
            this.fileListQT = fileList;
        },
        //    调用上传文件接口
        saveOneAttachment(fileUrl,formData){
            return req.post(fileUrl,formData).then(res => {
                if (res.data.code === 200) {
                    return res.data
                }else{
                    throw new Error(res.data.message || '上传失败');
                }
            })
        },
        // 确认上传文件
        async sureUpload(){
            // if(this.fileList.length){
                try {
                    // 创建Promise数组
                    // 报关发票
                    if (this.fileListBGZL.length > 0) {
                        const promisesBGZL = this.fileListBGZL.map(item => {
                            const formDataBGZL = new FormData();
                            formDataBGZL.append('file', item.raw);
                            formDataBGZL.append('businessId', this.queryParams.id);
                            formDataBGZL.append('annexType', '报关资料');
                            let fileUrl = `${url1.saveOneAttachment}`
                            return this.saveOneAttachment(fileUrl, formDataBGZL);
                        });
                        await Promise.all(promisesBGZL);
                    }
                     // 报关单
                    if (this.fileListBGD.length > 0) {
                        const promisesBGD = this.fileListBGD.map(item => {
                            const formDataBGD = new FormData();
                            formDataBGD.append('file', item.raw);
                            formDataBGD.append('businessId', this.queryParams.id);
                            formDataBGD.append('annexType', '报关单');
                            let fileUrl = `${url1.saveOneAttachment}`
                            return this.saveOneAttachment(fileUrl, formDataBGD);
                        });
                        await Promise.all(promisesBGD);
                    }
                     // 签收单
                    if (this.fileListQSD.length > 0) {
                        const promisesQSD = this.fileListQSD.map(item => {
                            const formDataQSD = new FormData();
                            formDataQSD.append('file', item.raw);
                            formDataQSD.append('businessId', this.queryParams.id);
                            formDataQSD.append('annexType', '签收单');
                            let fileUrl = `${url1.saveOneAttachment}`
                            return this.saveOneAttachment(fileUrl, formDataQSD);
                        });
                        await Promise.all(promisesQSD);
                    }
                     // 其他
                    if (this.fileListQT.length > 0) {
                        const promisesQT = this.fileListQT.map(item => {
                            const formDataQT = new FormData();
                            formDataQT.append('file', item.raw);
                            formDataQT.append('businessId', this.queryParams.id);
                            formDataQT.append('annexType', '其他');
                            let fileUrl = `${url1.saveOneAttachment}`
                            return this.saveOneAttachment(fileUrl, formDataQT);
                        });
                        await Promise.all(promisesQT);
                    }
                    // 完成后操作
                    this.fileListBGZL = [];
                    this.fileListBGD = [];
                    this.fileListQSD = [];
                    this.fileListQT = [];
                    this.uploadCode = false;
                } catch (error) {
                    this.$message.error('上传失败: ' + error.message);
                }
            // }else{
            //     this.$message({
            //         message: '请选择要上传的文件',
            //         type: 'warning'
            //     });
            // }
        },
        // 关闭上传文件弹窗
        handleCloseUpload(){
            this.uploadCode = false
            this.fileList = []
        },
        // 文件预览
        downloadFile(data){
            const params = {
                path: '/preview',
                query: {
                    annexUrl: data.annexUrl,
                    annexName: data.annexName
                }
            }
            window.open(this.$router.resolve(params).href, '_blank') // 这个就是打开新链接的方式
        },
        // 录入人过滤
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },
        // 打开查看上传附件列表
        searchuploadList(){
            this.getFileListByBusinessId()
            this.searchuploadListCode = true
        },
        handleCloseUploadList(){
            this.searchuploadListCode = false
            this.uploadedList = []
        },
        delFile(data){
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let URL = `${url1.deleteAttachmentBy}/${data.id}`;
                req.delete(URL).then(res => {
                    if(res.data.code === 200){
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getFileListByBusinessId()
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.data.data
                        });
                    }
                })
            }).catch(() => { })
        },
        copAdd(code){
            // FP 应收  FK应付
            var selectList = []
            this.applyCode = code;
            if(code === 'FP'){
                selectList = JSON.parse(JSON.stringify(this.receiveSelectList));
            }else{
                selectList = JSON.parse(JSON.stringify(this.paymentSelectList));// 详细数据
            }
            if(selectList.length <= 0){
                this.$message.warning(code === 'FK' ? '请选择应付数据！': '请选择应收数据！');
                return false
            }
            selectList.map(item => { 
                item.editing = true
                item.id = ''
                item.finance = 0
                item.createMan = this.myself
                if(code === 'FP'){
                    this.intableData.push(item)
                }else{
                    this.extableData.push(item)
                }
            })
        
        },
        // 查看收付款费用凭证
        feeVoucher(data){
            this.feeVoucherId = data.id
        },
        closeFeeVoucher(){
            this.feeVoucherId = ''
        }
    },
}
</script>

<style lang="css" scoped>
.containerNoList{
    display: flex;
    flex-direction: column;

}
/* 超出显示省略号 */
.ellipsis{
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
.redtext{
    margin-left: 20px;
    color: red; 
    font-weight: bolder;
    font-size: large;
}
.profittext{
    margin-left: 20px; 
    font-size: 1.1rem;
}
.css-button-3d--blue {
    /* min-width: 130px; */
    /* height: 40px; */
    color: #fff;
    /* padding: 5px 10px; */
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
    outline: none;
    /* border-radius: 5px; */
    border: none;
    background: #3d348b;
    box-shadow: 0 4px #2c0b8e;
}

.css-button-3d--blue:hover {
    box-shadow: 0 3px #2c0b8e;
    top: 1px;
}

.css-button-3d--blue:active {
    box-shadow: 0 0 #2c0b8e;
    top: 4px;
}

.css-button-3d--blue1 {
    /* min-width: 130px; */
    /* height: 40px; */
    color: #fff;
    /* padding: 5px 10px; */
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
    outline: none;
    /* border-radius: 5px; */
    border: none;
    background: #8b347f;
    box-shadow: 0 4px #8e0b78;
}

.css-button-3d--blue1:hover {
    box-shadow: 0 3px #2c0b8e;
    top: 1px;
}

.css-button-3d--blue1:active {
    box-shadow: 0 0 #2c0b8e;
    top: 4px;
}


.title-block {
    display: inline-block;
    position: relative;
    background: #27ae60;
    color: white;
    text-align: center;
    padding: 0px 20px 0px 10px;
    height: 35px;
    line-height: 35px;
    border-radius: 0px 20px 20px 0px;
    letter-spacing: 1px;
    font-weight: bold;
    font-size: 1.1rem;
}
.table-box {
    color: black;
    /* font-size: calc(14vw * 100 / 1920); */
    font-size: 13px;
    margin-top: 0;
    /* line-height: 1vh; */
    /* max-height: calc(33.9vh); */
    /* overflow-y: auto; */
}

::v-deep .el-input__icon {
    height: none;
    line-height: 50%;
}

::v-deep .el-main {
    overflow-x: hidden !important;
}

::v-deep .el-main>header {
    overflow-x: hidden !important;
}

::v-deep .el-button--text {
    padding: 0.1vh 0.1vh;
}

::v-deep .table-box .cell{
    line-height: 1vh;
}
::v-deep .table-box .el-table__cell {
    /* margin-right: 3px; */
    /* white-space: nowrap; */
    /* overflow: visible; */
    padding: 0px 0px;
    /* width: 100%; */
}
::v-deep .el-table .cell {
    white-space: nowrap; 
    overflow: visible;
    /* word-break: keep-all; */
    /* background-color: antiquewhite; */
    padding-left: 0;
    padding-right: 0;
    /* margin-right: 30px !important; */
    /* margin-right: 10px; */
    box-sizing: border-box;
    /* width: 100%; */
    /* line-height: 1vh; */
}
::v-deep .el-form-item {
    margin-bottom: 2px;
}
::v-deep .el-form-item__label {
    font-size: 12px;
}
::v-deep  .table-box  .cell {
    line-height: 1.5vh;
}
::v-deep .table-box .el-table__cell gutter {
    display: table-cell !important;
}
::v-deep .current-row>td {
    background: rgba(0, 158, 250, 0.219) !important;
}

::v-deep .el-table__row--selected {
    background-color: aqua !important;
}
::v-deep( .transparent .el-input--suffix .el-input__inner) {
    background-color: rgba(240, 248, 255, 0) !important;

}
::v-deep(.transparent .el-input__inner) {
    height: 100%;
    background-color: rgba(240, 248, 255, 0) !important;

}
::v-deep .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #676767;
}
::v-deep .el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 1px solid #898989;
}
.upload_box{
    display: flex;
    flex-direction: column;
}
.upload-list{
    display: flex;
    margin: 5px 10px;
    /* width: 90vw;*/
    /* min-width: 600px;  */
    /* display: flex; */
}
.list-margin{
    margin: 0px 5px;
}
</style>